const policyCancellationAction = {
    DELETE_DRAFT_CANCELLATION : 'delete draft cancellation',

    REQUEST_CANCELLATION : 'request cancellation',

    RETRACT_CANCELLATION_REQUEST : 'retract cancellation request',

    SUBMIT_FOR_CANCELLATION : 'submit for cancellation',

    RESCIND_CANCELLATION : 'rescind cancellation',

    MARK_AS_CANCELLED : 'mark as cancelled',

    REVERT_TO_CANCELLATION_PENDING : 'revert to cancellation pending'

};

angular.module('gw-um-j2js')
    .constant('policyCancellationAction', policyCancellationAction);